
















































































import { Component, Prop, Watch } from 'vue-property-decorator';
import AmountSelector from '@/common/AmountSelector.vue';
import UnitSelector from '@/common/UnitSelector.vue';
import EssenceDropdown from '@/common/EssenceDropdown.vue';
import CustomSelect from '@/common/CustomSelect.vue';
import { UnitDefinition } from '@/services/ProductDeserializer';
import {
  EssenceItemDto,
  ProductAttributeType,
  ProductAttributeInfo,
  ProductDto,
  OrderTemplateDto
} from '@eurogast/hub-client-typescript';
import OrderTemplateSelection from '@/common/OrderTemplateSelection.vue';
import SelectItem from '@/common/SelectItem';
import { LockService } from '@/services/LockService';
import LabelSelection from '@/common/LabelSelection.vue';
import ProductDtoComponentBase from '@/common/ProductDtoComponentBase';
import ProductBadges from '@/search-result/ProductBadges.vue';
import { CartItem } from '@/services/cart/model/cart';
import { DependencyService } from '@/services/DependencyService';
import MatomoEvents from '@/matomo/events/MatomoEvents';
import { OrderTemplateDeserializer } from '@/services/OrderTemplateDeserializer';
import { CONVI_KEY } from '@/services/product/ProductService';

@Component({
  components: {
    OrderTemplateSelection,
    UnitSelector,
    AmountSelector,
    EssenceDropdown,
    CustomSelect,
    LabelSelection,
    ProductBadges
  }
})
export default class PageCartItem extends ProductDtoComponentBase {
  get orderTemplates(): OrderTemplateDto[] {
    return OrderTemplateDeserializer.parseOrderTemplateList(this.localOrderTemplateList);
  }

  get currentUnitItem(): SelectItem {
    return new SelectItem(this.currentUnit.abbreviation, [this.currentUnit.name], this.currentUnit);
  }

  get currentUnitName(): string {
    return this.currentUnit.name;
  }

  get product(): ProductDto {
    return this.item.product;
  }

  get currentUnit(): UnitDefinition {
    return this.item.unit;
  }

  set currentUnit(ignore: UnitDefinition) {
    // no-op - used by super
  }

  get currentAmount(): number {
    return this.item.amount;
  }

  get currentMinSaleQuantity() {
    return this.item.product.minSaleQuantity / (!this.currentUnit ? 1 : this.currentUnit.ratio);
  }

  get clonedItem(): CartItem {
    return this.item.clone();
  }

  get isPreorder(): boolean {
    return this.item.product.attributes.some((info) => info.key === ProductAttributeType.Bestellartikel);
  }

  get isConvenienceProduct() {
    return this.product.virtualCategories.some((virtualCategory) => virtualCategory === CONVI_KEY);
  }

  get clearedAttributes(): ProductAttributeInfo[] {
    // remove attributes which should not be displayed
    return this.item.product.attributes.filter(
      (info) => info.key !== ProductAttributeType.Bestellartikel);
  }

  get visibleUnitNames(): SelectItem[] {
    return this.visibleUnits.sort((a, b) => a.ratio - b.ratio)
      .map((unit: UnitDefinition) => new SelectItem(unit.abbreviation, [unit.name], unit));
  }

  get zIndexOrderTemplateSelection(): string {
    return String(this.zIndexEssence + 1);
  }

  get zIndexEssence() {
    return this.zIndexUnit + 1;
  }

  get zIndexUnit() {
    return (100 + (this.length * 2)) - (2 * this.index);
  }

  @Prop({ required: true })
  public item: CartItem;
  @Prop({ required: true })
  public removed: boolean;
  @Prop({ required: true })
  public essences: EssenceItemDto[];
  @Prop({ required: true })
  public index: number;
  @Prop({ required: true })
  public length: number;
  @Prop({ required: false, default: null })
  public localOrderTemplateList: string;
  @Prop({ required: false, default: false })
  public labelSelection: boolean;

  @Prop( { required: false, default: true })
  public showLabelPrintIcon: boolean;
  @Prop( { required: false, default: true })
  public showOrderTemplateIcon: boolean;

  public currentAmountString: string = '1';

  private cartService = DependencyService.getCartService();
  private lockService: LockService;

  @Watch('currentUnit')
  public onUnitItemChange(newValue) {
    if ((this.item as any).removed) {
      return;
    }
    if (this.currentAmount * newValue.ratio < this.item.product.minSaleQuantity) {
      this.onAmountChange(Math.ceil(this.item.product.minSaleQuantity / newValue.ratio));
    }
    this.cartService.putItem(this.clonedItem);
  }

  public onAmountChange(amount) {
    if (this.isValidAmount(amount)) {
      const item = Object.assign({}, this.item, { amount });
      this.cartService.putItemWithLock(item, this.lockService);
    }
  }

  public onUnitChange(current: SelectItem) {
    MatomoEvents.forCartPage.unitChange.publishFromCart();
    const item = Object.assign({}, this.item, { unitAbbreviation: current.obj.abbreviation });
    this.cartService.putItemWithLock(item, this.lockService);
  }

  public removeFromCart() {
    MatomoEvents.forCartPage.removeItem.publish();
    this.cartService.removeItem(this.item);
  }

  public restoreIntoCart() {
    MatomoEvents.forCartPage.restoreItem.publish();
    this.cartService.putItem(this.item);
  }

  public mounted() {
    super.mounted();
    this.lockService = new LockService(this.beforeUnload.bind(this), 1000);
  }

  public beforeUnload() {
    this.cartService.putItem(this.clonedItem, true);
  }

  private setCurrentAmountString(argument) {
    MatomoEvents.forCartPage.amountChange.publishFromCart();
    this.currentAmountString = argument;
    this.onAmountChange(argument);
  }
}
